export enum LetterSectionView {
  NO_LETTER = 'NO_LETTER',
  UPLOAD_FILE = 'UPLOAD_FILE',
  PREVIEW = 'TEMPLATE',
  EDIT = 'EDIT',
}

export enum LetterDialogTypes {
  ADD = 'ADD',
  SIGNOFF = 'SIGNOFF',
  SHARE = 'SHARE',
  REMOVE = 'REMOVE',
  CONFIG = 'CONFIG',
  DELETE = 'DELETE',
  FIRM_SIGNOFF = 'FIRM_SIGNOFF',
  CLIENT_SIGNOFF = 'CLIENT_SIGNOFF',
  CHECKLIST = 'CHECKLIST',
  LETTER = 'LETTER',
  TIME_ZONE = 'TIME_ZONE',
  CANCEL = 'CANCEL',
  RESEND_EDIT = 'RESEND_EDIT',
  DATE_PICKER = 'DATE_PICKER',
  HEADER_REQ = 'HEADER_REQ',
  PREVIEW = 'PREVIEW',
  ENG_LETTER = 'ENG_LETTER',
}

export class LetterClientSignTypes {
  DRAW = 3;
  TEXT = 4;
  UPLOAD = 5;
}

export const CLIENT_SIGN_LIST: { radioId: 0 | 3 | 4 | 5 , radioName: string }[] = [
  {
    "radioId": 3,
    "radioName": "Draw"
  },
  {
    "radioId" : 4,
    "radioName" : "Type"
  },
  {
    "radioId" : 5,
    "radioName" : "Upload"
  }
]

export enum LetterClientSignTab {
  TERMS = 'TERMS_TAB',
  SIGNOFF = 'SIGNOFF_TAB',
  NONE = 'NONE'
}
